import type { BusinessGraphDiffResultV1 } from "@enrein/shared-contracts";

export type BusinessGraphDiffPanelProps = {
  readonly diff: BusinessGraphDiffResultV1 | null;
  readonly error?: string | null;
  readonly loading?: boolean;
};

/**
 * BG-008 — human-readable BusinessGraph revision diff surface.
 * Renders API summary lines only; never invents success when identical/empty.
 */
export function BusinessGraphDiffPanel(props: BusinessGraphDiffPanelProps) {
  const { diff, error, loading } = props;

  if (loading) {
    return (
      <section aria-label="BusinessGraph revision diff" data-testid="bg-diff-panel">
        <p>Loading revision diff…</p>
      </section>
    );
  }

  if (error) {
    return (
      <section aria-label="BusinessGraph revision diff" data-testid="bg-diff-panel">
        <p role="alert">{error}</p>
      </section>
    );
  }

  if (!diff) {
    return (
      <section aria-label="BusinessGraph revision diff" data-testid="bg-diff-panel">
        <p>Select two revisions to compare.</p>
      </section>
    );
  }

  return (
    <section aria-label="BusinessGraph revision diff" data-testid="bg-diff-panel">
      <h2>Revision diff</h2>
      <p>
        {diff.fromRevisionId} → {diff.toRevisionId}
      </p>
      {diff.identical ? (
        <p data-testid="bg-diff-identical">No differences.</p>
      ) : (
        <ul data-testid="bg-diff-summary">
          {diff.humanSummary.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}
    </section>
  );
}
